export enum FiTextPanelType {
    Simple,
    Advanced,
}
